import { CloudDownloadOutlined } from "@ant-design/icons";
import {
  Modal,
  Select,
  Tooltip,
  Typography,
  message,
} from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";
import "./FarmerReport.css";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { apiurls } from "../../resources/APIurls";
import { appconfig } from "../../resources/config";
import { postData } from "../../resources/utils";
import { encode } from "js-base64";
import moment from "moment";
import {
  LeftCircleOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
const { Option } = Select;

const FarmerReportDialog = ({
  farmerReportDialog,
  setFarmerReportDialog,
  data,
  cropHis,
  npk,
  health,
  featureType,
  farmerDetails,
  setMapLoader,
  googgleImages,
  coordinatesData,
  locationFilters,
  getIndexLatLngs,
  owsLayerData,
latestSeason,
heatMapData,
cropHealthMapLoader,
soilmoistureHeatMap
}) => {
  
  const [viChartOptions2, setViChartOptions2] = useState(null);
  const [smChartOptions, setSmChartOptions] = useState(null);
  const [ndwiChartOptions, setNdwiChartOptions] = useState(null);
  const [smLatlongData, setSmLatlongData] = useState([]);
  const [ndwiLatlongData, setNdwiLatlongData] = useState([]);
  const [yeildInfo, setYeildInfo] = useState([]);
  const [yieldLoading, setYieldLoading] = useState(false);
  const scrollRightRef = useRef(null);
  let apikey_s3 = apiurls.find((item) => item.apikey == "aws3");
  const aws_s3_url = `${appconfig.domain[appconfig.environment].aws3}${apikey_s3.paths.images
    }`;
  const [printLoader, setPrintLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [viLatlongData, setViLatlongData] = useState([]);
  const loadingMessage = () => {
    messageApi.open({
      type: "loading",
      content: "Your file is being ready, Please wait..",
      duration: 1.5,
    });
  };
  const successMessage = () => {
    messageApi.open({
      type: "success",
      content: "Your file is ready to download.",
      duration: 2,
    });
  };

const formatPart = (val) => {
  if (!val) return null;
  const str = val.toString().trim();
  if (!str || str.toUpperCase() === "NA") return null;
  return str.replace(/\s+/g, "_");
};

  const callPdfService = async (dataPDF) => {
    let res = await postData("indexhost", "getPdf", dataPDF, null);
    const linkSource = `data:application/pdf;base64,${res.data.data}`;
    const downloadLink = document.createElement("a");

    const fileName =
      [
        data?.khasra ? `Khasra no_${formatPart(data.khasra)}` : null,
        formatPart(data?.farmer_name),
        formatPart(data?.village_name),
        formatPart(data?.subdistrict_name),
        formatPart(data?.district_name),
        formatPart(data?.state_name),
      ]
        .filter(Boolean)
        .join("_") + ".pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    messageApi.destroy();
    successMessage();
    setMapLoader(false);
    downloadLink.click();
  };
  const downloadPdf = async () => {
    loadingMessage();
    setMapLoader(true);
    let target = document.getElementById("divToPrint");
    var wrap = document.createElement("div");
    wrap.appendChild(target.cloneNode(true));

    let startHtml = `<html><head><link rel='preconnect' href="https://fonts.googleapis.com" /><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin /><link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;400;500;600;700&display=swap" rel="stylesheet" /><style>@page {
    size: A4 landscape;  
    margin: 20px;
  }body {
    font-family: Poppins;
  }

  div, p, span {
    font-family: Poppins;
  }
</style>
</head>
<body>
`;
    let endHtml = `</body></html>`;
    let str = startHtml + wrap.innerHTML.replace(/\n|\t/g, " ") + endHtml;
    let data = {
      html: encode(str),
    };

    callPdfService(data);
  };

  const [pieChartOptions, setPieChartOptions] = useState({
  chart: {
    plotBackgroundColor: "#fffaf266",
    backgroundColor: "#fffaf266",
    plotBorderWidth: 0,
    plotShadow: false,
    type: "pie",
    height: 280,
    width: 280,
  },

  title: {
    text: "",
  },

  credits: {
    enabled: false,
  },

  tooltip: {
    pointFormat: "{point.name}: <b>({point.percentage:.1f}%)</b>",
  },

  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",

      dataLabels: {
        enabled: true,                 
        distance: -30,                
        formatter: function () {
          return `<b></b><br/> (${this.percentage.toFixed(1)}%)`;
        },
        style: {
          fontSize: "10px",
          fontWeight: "bold",
          textOutline: "none",
          color: "#000"
        }
      }
    }
  },

  series: [
    {
      name: "Area",
      colorByPoint: true,
      borderWidth: 0,

      data: [
        {
          name: "Good Area",
          y: 11.4,
          color: "#9FC088",
        },
        {
          name: "Moderate Area",
          y: 67.62,
          color: "#E8C07D",
        },
        {
          name: "Poor Area",
          y: 18.1,
          color: "#F55353",
        },
      ],
    },
  ],
});
const getYield = async () => {
  try {
    setYieldLoading(true); 
    const latlongpolygon = getIndexLatLngs(owsLayerData);

    if (!latlongpolygon?.length) {
      setYieldLoading(false);
      return;
    }

      const payload = {
        countryId: Number(locationFilters.country?.code),
        stateId: Number(locationFilters.state?.code),
        districtId: Number(locationFilters.city?.code),
        latlong: latlongpolygon
      };

      const res = await postData("indexhost", "khasra_yield", payload, null);
      const responseData = res?.data?.data;
      const seasonKey = latestSeason?.[0]?.season_name;

      if (!seasonKey) {
        setYieldLoading(false);
        return;
      }

      const latestSeasonData = responseData?.[seasonKey];
      if (!latestSeasonData?.length) {
        setYeildInfo([]);
        setYieldLoading(false);
        return;
      }

      const processedData = latestSeasonData.map((item) => {
        const min = Number(item?.minFarmLevelCropYield) || 0;
        const max = Number(item?.maxFarmLevelCropYield) || 0;

        const avgYield = (min + max) / 2;

        return {
          name: item?.crop,
          yield: Number(avgYield.toFixed(2)),
          unit: item?.cropYieldUnit,
        };
      });

      setYeildInfo(processedData);
      setYieldLoading(false);
      return processedData;
    } catch (error) {
      console.error("Error fetching yield:", error);
      setYeildInfo([]);
      setYieldLoading(false);
    }
  };
const getViLatlongData = async () => {
  try {
    setMapLoader(true);

    if (!owsLayerData?.features?.length) return;

    const latlongpolygon = getIndexLatLngs(owsLayerData);
    if (!latlongpolygon?.length) return;

    const indexTitleMap = {
      NDVI: "Vegetation Index",
      NDWI: "Water Index",
      SM: "Surface Moisture Index"
    };

    const indices = ["NDVI", "SM", "NDWI"];

    for (const indexType of indices) {
      const payload = {
        latlongpolygon,
        start_date: "2025-10-1",
        end_date: "2026-03-31",
        index: indexType,
        layer: `${locationFilters.country.label
          .split(" ")
          .join("")}_${locationFilters.state.label
          .split(" ")
          .join("_")}_${locationFilters.city.label.split(" ").join("")}`,
      };

      const res = await postData("indexhost", "vitallatlongs", payload, null);

      if (!res?.data?.error && res?.data?.data?.length) {
        const data = res.data.data;

        if (indexType === "NDVI") setViLatlongData(data);
        if (indexType === "SM") setSmLatlongData(data);
        if (indexType === "NDWI") setNdwiLatlongData(data);

        const chartData = data.map((item) => {
          const time = new Date(item.date).getTime();

          const actual = item.mean > 1 ? item.mean : item.mean * 100;
          const expected =
            item.expectedMean > 1
              ? item.expectedMean
              : item.expectedMean * 100;

          return { time, actual, expected };
        });

        const graphObj = {
          chart: {
            type: "line",
            height: 320, 
            spacingTop: 25,
            spacingBottom: 25,
            spacingLeft: 20,
            spacingRight: 20
          },

          title: {
            text: indexTitleMap[indexType],
            margin: 25
          },

          xAxis: {
            type: "datetime",
            min: chartData[0].time,
            max: chartData[chartData.length - 1].time,
            tickInterval: 15 * 24 * 3600 * 1000,
            labels: {
              format: "{value:%d %b %Y}"
            }
          },

          yAxis: {
            title: { text: `${indexTitleMap[indexType]} (%)` }
          },

          tooltip: {
            shared: false,
            formatter: function () {
              return `
                <b>${moment(this.x).format("DD MMM YYYY")}</b><br/>
                ${this.series.name}: <b>${this.y.toFixed(2)}%</b>
              `;
            }
          },

          plotOptions: {
            series: {
              marker: {
                enabled: true,
                radius: 3
              },
              dataLabels: {
                enabled: true,
                inside: false,
                allowOverlap: false,
                crop: false,
                overflow: "none",
                padding: 2,
                style: {
                  fontSize: "10px"
                }
              }
            }
          },

          series: [
            {
              name: "Actual",
              data: chartData.map((d) => [d.time, d.actual]),
              color: "#7BB4EC",
              dataLabels: {
                align: "center",
                verticalAlign: "top",
                y: -8, 
                formatter: function () {
                  return this.y.toFixed(2);
                }
              }
            },
            {
              name: "Ideal",
              data: chartData.map((d) => [d.time, d.expected]),
              color: "#434348",
              dashStyle: "Dash",
              dataLabels: {
                align: "center",
                verticalAlign: "bottom",
                y: 12, 
                formatter: function () {
                  return this.y.toFixed(2);
                }
              }
            }
          ],

          exporting: {
            sourceWidth: 900,
            sourceHeight: 400,
            chartOptions: {
              chart: {
                height: 350
              },
              plotOptions: {
                series: {
                  dataLabels: {
                    enabled: true,
                    inside: false,
                    allowOverlap: false,
                    crop: false,
                    overflow: "none",
                    style: {
                      fontSize: "9px"
                    }
                  }
                }
              }
            }
          },

          credits: {
            enabled: false
          }
        };

        if (indexType === "NDVI") setViChartOptions2(graphObj);
        if (indexType === "SM") setSmChartOptions(graphObj);
        if (indexType === "NDWI") setNdwiChartOptions(graphObj);
      }
    }
  } catch (err) {
    console.error("Error:", err);
  } finally {
    setMapLoader(false);
  }
};

  useEffect(() => {
    getViLatlongData()
    getYield();
  }, [])
  const getCropHistoryRows = (seasonType) => {
    let rows = "";

    const filteredKeys = Object.keys(cropHis)
      .filter((key) => key.includes(seasonType))
      .sort((a, b) => b.localeCompare(a))
      .slice(0, 2);

    filteredKeys.forEach((key, index) => {
      const crops = cropHis[key];

      rows += `
      <tr style="background:${index % 2 === 0 ? "#fff" : "#f9f9f9"};">
        <td style="padding:10px; font-weight:600;">${key}</td>
        <td style="padding:10px;">
          ${crops && crops.length
          ? crops.map((item) => item.name).join(", ")
          : "--"
        }
        </td>
      </tr>
    `;
    });

    return rows || `<tr><td colspan="2">No Data Found</td></tr>`;
  };

  const [selectedFarmer, setSelectedFarmer] = useState({});
  const [farmerInfo, setFarmerInfo] = useState({});
  const [farmerId, setFarmerId] = useState("");

  // useEffect(() => {
  //   if (featureType != "frams" && data.farmerdetails1?.length > 1) {
  //     setSelectedFarmer(data.farmerdetails1[0]);
  //     setFarmerId(data.farmerdetails1[0].id);
  //     setFarmerInfo(data.farmerdetails[0]?.farmername);
  //   }
  // }, []);

  const findFarmerId = (val) => {
    const selectedFarmerId = data.farmerdetails1.find(
      (item) => item.id == farmerId
    );

    setSelectedFarmer(selectedFarmerId);
  };

  // const findFarmerBasicInfo = () => {
  //   setFarmerInfo(
  //     data.find(
  //       (info) => info.farmername == selectedFarmer?.farmer_name
  //     )
  //   );
  // };

  useEffect(() => {
    if (featureType != "farms") {
      // findFarmerId();
      // findFarmerBasicInfo();
    }
  }, [farmerId]);

  useEffect(() => {
    let chartObj = { ...pieChartOptions };
    chartObj.series[0].data[0].y = health?.good;
    chartObj.series[0].data[1].y = health?.average;
    chartObj.series[0].data[2].y = health?.poor;

    setPieChartOptions(chartObj);
  }, [health]);

  const randomNumGenerator = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };


const getLongLat = (data) => {
  if (Array.isArray(data) && data.length >= 2) {
    return {
      long: data[0],
      lat: data[1],
    };
  }

  if (
    data &&
    typeof data === "object" &&
    "latitude" in data &&
    "longitude" in data
  ) {
    return {
      long: data.longitude,
      lat: data.latitude,
    };
  }

  return null;
};
const scrollHorizontally = (offset) => {
  if (scrollRightRef.current) {
    scrollRightRef.current.scrollLeft += offset;
  }
};

const lastHeatMap = soilmoistureHeatMap?.length
  ? soilmoistureHeatMap[soilmoistureHeatMap.length - 1]
  : null;

  return (
    <div>
      <Modal
        title=""
        visible={farmerReportDialog}
        onCancel={() => setFarmerReportDialog(false)}
        footer={null}
        bodyStyle={{
          backgroundColor: "#FFFFFF",
          transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)",
        }}
        width={"90%"}
        centered
      >
        {printLoader ? (
          <div className="loader-cont">
            <img src={`${aws_s3_url}/loader2.gif`} width="100px" />

            <p className="back-drop-text-2">
              Your Report is geting ready, Please wait..
            </p>
          </div>
        ) : (
          <Fragment>
            {contextHolder}
            <div style={{ marginTop: "16px" }}>
              <Tooltip title="Download" placement="right">
                <CloudDownloadOutlined
                  onClick={downloadPdf}
                  style={{
                    color: "#212121",
                    fontSize: "25px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
              {data.farmerdetails1?.length > 1 && (
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <Select
                      defaultValue={data.farmerdetails1[0].farmer_name}
                      style={{
                        width: "30%",
                      }}
                      value={farmerId || undefined}
                      onChange={(val) => {
                        setFarmerId(val);
                      }}
                    >
                      {data.farmerdetails1.map((item, index) => (
                        <Option key={index} value={item.id}>
                          {item.farmer_name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                )}
              </div>
              <div
                style={{
                  borderRadius: "6px",
                  padding: "20px",
                  marginTop: "30px",
                }}
                id="divToPrint"
              >
                {/* LOGO HEADER */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <img src={`${aws_s3_url}/logo.svg`} style={{ width: "110px" }} />
                  <img src={`${aws_s3_url}/AgribazaarLogo.svg`} style={{ width: "110px" }} />
                </div>

                {/* HERO SECTION */}
                <div
                  style={{
                    backgroundImage: `url(${aws_s3_url}/farmfield.png)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    padding: "50px 25px",
                    minHeight: "260px",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(0,0,0,0.45)",
                    }}
                  ></div>

                  {/* CONTENT */}
                  <div style={{ position: "relative", zIndex: 2 }}>

                    {/* Title */}
                    <p
                      style={{
                        fontSize: "60px",
                        fontWeight: "700",
                        margin: 0,
                        color: "#ffffff",
                        letterSpacing: "1px",
                      }}
                    >
                      Farm Report
                    </p>

                    {/* Subtitle */}
                    <p
                      style={{
                        fontSize: "22px",
                        fontWeight: "500",
                        marginTop: "8px",
                        color: "#e6e6e6",
                      }}
                    >
                      Detailed Farm & Crop Information
                    </p>

                    {/* Bottom Section */}
                    <div style={{ marginTop: "60px" }}>
                      <p
                        style={{
                          fontSize: "28px",
                          fontWeight: "600",
                          color: "#ffffff",
                          margin: 0,
                          borderLeft: "4px solid #9acd32",
                          paddingLeft: "10px",
                        }}
                      >
                        Farm Details
                      </p>
                    </div>
                    {farmerId !== "" && featureType == 9 ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "16px",
                          marginTop: "40px",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        {/* CARD 1 */}
                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #dcdcdc",
                            borderRadius: "8px",
                            padding: "14px 18px",
                            flex: "1 1 300px",
                            minWidth: "280px",
                          }}
                        >
                          {/* State */}
                          <div style={{ marginBottom: "10px", borderBottom: "1px dashed #ddd", paddingBottom: "6px" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              State
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.state_name || "NO DATA"}
                            </p>
                          </div>

                          {/* District */}
                          <div style={{ marginBottom: "10px", borderBottom: "1px dashed #ddd", paddingBottom: "6px" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              District
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.district_name || "NO DATA"}
                            </p>
                          </div>

                          {/* Tehsil */}
                          <div>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Tehsil
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.subdistrict_name || "NO DATA"}
                            </p>
                          </div>
                        </div>

                        {/* CARD 2 */}
                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #dcdcdc",
                            borderRadius: "8px",
                            padding: "14px 18px",
                            flex: "1 1 300px",
                            minWidth: "280px",
                          }}
                        >
                          {/* Village */}
                          <div style={{ marginBottom: "10px", borderBottom: "1px dashed #ddd", paddingBottom: "6px" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Village
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.village_name || "NO DATA"}
                            </p>
                          </div>

                          {/* Khasra */}
                          <div style={{ marginBottom: "10px", borderBottom: "1px dashed #ddd", paddingBottom: "6px" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Khasra Number
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.khasra || "NO DATA"}
                            </p>
                          </div>

                          {/* Mobile */}
                          <div>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Mobile
                            </p>
                            <p style={{ fontSize: "15px", margin: 0 }}>
                              {data?.farmerdetails1?.[0]?.mobile || "NO DATA"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : featureType != "farms" ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "16px",
                          marginTop: "40px",
                          flexWrap: "wrap",
                          width: "100%",
                        }}
                      >
                        {/* CARD 1 */}
                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #dcdcdc",
                            borderRadius: "10px",
                            padding: "16px",
                            flex: "1 1 300px",
                            minWidth: "280px",
                          }}
                        >
                          {[
                            { label: "State", value: data?.state_name },
                            { label: "District", value: data?.district_name },
                            { label: "Tehsil", value: data?.subdistrict_name },
                            { label: "Village", value: data?.village_name },
                            { label: "Khasra Number", value: data?.khasra },
                          ].map((item, index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: index !== 4 ? "12px" : 0,
                                paddingBottom: index !== 4 ? "8px" : 0,
                                borderBottom: index !== 4 ? "1px dashed #ddd" : "none",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  color: "#6f9300",
                                  fontWeight: "600",
                                  margin: 0,
                                }}
                              >
                                {item.label}
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  margin: 0,
                                  color: "#2c2c2c",
                                }}
                              >
                                {item.value || "—"}
                              </p>
                            </div>
                          ))}
                        </div>

                        {/* CARD 2 */}
                        <div
                          style={{
                            background: "#ffffff",
                            border: "1px solid #dcdcdc",
                            borderRadius: "10px",
                            padding: "16px",
                            flex: "1 1 300px",
                            minWidth: "280px",
                          }}
                        >
                          {/* Current Season */}
                          <div style={{ marginBottom: "12px", paddingBottom: "8px", borderBottom: "1px dashed #ddd" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Current Season
                            </p>
                            <p style={{ fontSize: "15px", fontWeight: "500", margin: 0, color: "#2c2c2c" }}>
                              {data?.current_season || "—"}
                            </p>
                          </div>

                          {/* Soil Type */}
                          <div style={{ marginBottom: "12px", paddingBottom: "8px", borderBottom: "1px dashed #ddd" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Soil Type
                            </p>
                            <p style={{ fontSize: "15px", fontWeight: "500", margin: 0, color: "#2c2c2c" }}>
                              {data?.soil_type || "—"}
                            </p>
                          </div>

                          {/* Current Crops */}
                          <div style={{ marginBottom: "12px", paddingBottom: "8px", borderBottom: "1px dashed #ddd" }}>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Current Crops
                            </p>
                            <p style={{ fontSize: "15px", fontWeight: "500", margin: 0, color: "#2c2c2c" }}>
                              {data?.current_crops?.length
                                ? data.current_crops.join(", ")
                                : "Not Available"}
                            </p>
                          </div>

                          {/* Yield Section */}
                          <div>
                            <p style={{ fontSize: "13px", color: "#6f9300", fontWeight: "600", margin: 0 }}>
                              Crop Yield (Latest Season)
                            </p>

                            {/* Loader */}
                            {yieldLoading ? (
                              <div
                                style={{
                                  marginTop: "10px",
                                  fontSize: "14px",
                                  color: "#999",
                                }}
                              >
                                Loading yield data...
                              </div>
                            ) : yeildInfo?.length ? (
                              <div
                                style={{
                                  marginTop: "10px",
                                  border: "1px solid #e5e5e5",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                }}
                              >
                                {/* Table Header */}
                                <div
                                  style={{
                                    display: "flex",
                                    background: "#f6f9f2",
                                    padding: "8px 10px",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "#2c2c2c",
                                  }}
                                >
                                  <div style={{ flex: 1 }}>Crop</div>
                                  <div style={{ width: "100px", textAlign: "right" }}>Yield</div>
                                </div>

                                {/* Table Body */}
                                {yeildInfo.map((item, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      padding: "8px 10px",
                                      borderTop: "1px solid #eee",
                                    }}
                                  >
                                    <div style={{ flex: 1, fontSize: "14px", color: "#2c2c2c" }}>
                                      {item.name}
                                    </div>

                                    <div
                                      style={{
                                        width: "100px",
                                        textAlign: "right",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#6f9300",
                                      }}
                                    >
                                      {item.yield} q/ha
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p style={{ fontSize: "14px", color: "#999", marginTop: "10px" }}>
                                No Yield Data
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "31.5%",
                      }}
                    >
                      {/* 1 div-------------------->>>>>>>>>>>>>>>>>>>>> */}
                      <div
                        style={{
                          // background: "#364C01",
                          background:"rgb(255 255 255 / 90%)",
                          border: "1px solid #e0e0e0",
                          width: "28%",
                          padding: "5px 25px 5px 25px",
                        }}
                      >
                       
                          <div style={{}}>
                            <p
                              style={{
                                fontSize: '20px',
                                fontWeight: '700',
                                lineHeight: '27px',
                                letterSpacing: '0px',
                                textAlign: 'left',
                                color: '#000000'
                              }}
                            >State</p>
                            <p style={{
                              fontSize: '14px',
                              fontWeight: 400,
                              lineHeight: '19px',
                              letterSpacing: '0px',
                              textAlign: 'left',
                              color: '#000000',
                              marginTop: '14px'
                            }} >
                              {farmerDetails.state_name != null
                                ? farmerDetails.state_name
                                : "NA"}
                            </p>
                          </div>
                          <div style={{}}>
                            <p
                              style={{
                                fontSize: '20px',
                                fontWeight: '700',
                                lineHeight: '27px',
                                letterSpacing: '0px',
                                textAlign: 'left',
                                color: '#000000'
                              }}
                            >District</p>
                            <p style={{
                              fontSize: '14px',
                              fontWeight: 400,
                              lineHeight: '19px',
                              letterSpacing: '0px',
                              textAlign: 'left',
                              color: '#000000',
                              marginTop: '14px'
                            }} >
                              {farmerDetails.district_name != null
                                ? farmerDetails.district_name
                                : "NA"}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            // background: "#364C01",
                            background: "rgb(255 255 255 / 90%)",
                            border: "1px solid #e0e0e0",
                            width: "28%",
                            padding: "5px 25px 5px 25px",
                          }}
                        >
                        </div>
                        <div
                          style={{
                            background: "#364C01",
                            width: "28%",
                            padding: "5px 25px 5px 25px",
                          }}
                        >
                        </div>
                        <div
                          style={{
                            background: "#364C01",
                            width: "10%",
                            padding: "5px 17px 5px 18px ",
                          }}
                        >
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* SOIL PROPERTIES MAIN DIV----------------------->>>>>>>>>>>>>>>... */}
                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 20px",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "20px",
                    background: "#fff",
                    marginTop: "5%",
                  }}
                >
                  {/* Header */}
                  <p
                    style={{
                      color: "#2f3e0a",
                      fontSize: "26px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      borderBottom: "2px solid #e6e6e6",
                      paddingBottom: "10px",
                      fontFamily: "Poppins"
                    }}
                  >
                    Soil Properties
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                    }}
                  >
                    {/* ================= MACRO ================= */}
                    <div style={{ width: "50%" }}>
                      <p style={{ fontSize: "20px", fontWeight: 700, color: "#6f9300" }}>
                        Macro Nutrients
                      </p>

                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {[
                          { label: "Nitrogen (N)", value: npk?.nitrogen },
                          { label: "Phosphorus (P)", value: npk?.phosphorus },
                          { label: "Potassium (K)", value: npk?.potassium },
                        ].map((item, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              padding: "10px",
                              background: "#fff",
                            }}
                          >
                            <span style={{ fontWeight: 500 }}>{item.label}</span>
                            <span>
                              {item.value != null ? `${item.value} kg/ha` : "--"}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* ================= MICRO ================= */}
                    <div style={{ width: "50%" }}>
                      <p style={{ fontSize: "20px", fontWeight: 700, color: "#6f9300" }}>
                        Micro Nutrients
                      </p>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {[
                          ["Boron", npk?.boron],
                          ["Zinc", npk?.zinc],
                          ["Iron", npk?.iron],
                          ["Sulphur", npk?.sulphur],
                          ["Manganese", npk?.manganese],
                          ["Copper", npk?.copper],
                        ].map(([name, value], i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              padding: "10px",
                              background: "#fff",
                            }}
                          >
                            <span style={{ fontWeight: 500 }}>{name}</span>
                            <span>{value ?? "--"} ppm</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* ================= HEALTH TABLE ================= */}
                  <div style={{ marginTop: "40px", pageBreakInside: "avoid" }}>
                    <p
                      style={{
                        fontSize: "22px",
                        fontWeight: 400,
                        color: "#585757",
                        fontFamily: "Poppins",
                      }}
                    >
                      Soil Health Index Table
                    </p>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid #e6e6e6",
                        borderRadius: "8px",
                        overflow: "hidden",
                        fontFamily: "Poppins",
                      }}
                    >
                      <thead>
                        <tr style={{ background: "#f5f5f5" }}>
                          {["Range", "Nitrogen", "Phosphorus", "Potassium"].map((h, i) => (
                            <th
                              key={i}
                              style={{
                                padding: "12px",
                                border: "1px solid #ddd",
                                fontWeight: 600,
                                textAlign: "center",
                              }}
                            >
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ background: "#B0E896" }}>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>Good</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>226+ kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>23+ kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>136+ kg/acre</td>
                        </tr>

                        <tr style={{ background: "#F9FFC2" }}>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>Average</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>113-226 kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>9-23 kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>58-136 kg/acre</td>
                        </tr>

                        <tr style={{ background: "#F97979", color: "#fff" }}>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>Poor</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>0-113 kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>0-9 kg/acre</td>
                          <td style={{ padding: "12px", border: "1px solid #ddd" }}>0-58 kg/acre</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* SOIL PROPERTIES----------------------------------------------------------------- */}
                {/* CROP HISTORY -------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 20px",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "20px",
                    background: "#fff",
                    marginTop: "5%",
                    overflow: "hidden",
                    pageBreakInside: "avoid",
                    breakInside: "avoid"
                  }}
                >
                  {/* Header */}
                  <p
                    style={{
                      color: "#2f3e0a",
                      fontSize: "26px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      borderBottom: "2px solid #e6e6e6",
                      paddingBottom: "10px",
                      fontFamily: "Poppins"
                    }}
                  >
                    Soil & Water Index Analysis
                  </p>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px"
                    }}
                  >

                    {/* ================= SM ================= */}
                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "320px",
                        background: "#f9fafc",
                        borderRadius: "8px",
                        padding: "12px",
                        boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                        display: "flex",
                        flexDirection: "column",
                        pageBreakInside: "avoid",
                        breakInside: "avoid"
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "600",
                          color: "#4a6b00",
                          marginBottom: "10px",
                          fontSize: "18px",
                          fontFamily: "Poppins",
                          textAlign: "center"
                        }}
                      >
                        Soil Moisture
                      </p>

                      {smChartOptions ? (
                        <HighchartsReact highcharts={Highcharts} options={smChartOptions} />
                      ) : (
                        <p style={{ textAlign: "center" }}>Loading...</p>
                      )}

                      {smLatlongData?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            borderTop: "1px solid #eee",
                            paddingTop: "8px",
                            overflow: "hidden"
                          }}
                        >
                          <LeftCircleOutlined
                            onClick={() => scrollHorizontally(-120)}
                            style={{ marginRight: "10px", cursor: "pointer" }}
                          />

                          <div
                            style={{
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              flex: 1
                            }}
                          >
                            {smLatlongData.map((item, index) => (
                              <span
                                key={index}
                                style={{
                                  display: "inline-block",
                                  padding: "6px 12px",
                                  marginRight: "8px",
                                  borderRadius: "20px",
                                  background: "#e8f5e9",
                                  fontSize: "13px",
                                  fontWeight: "500"
                                }}
                              >
                                {moment(item.date).format("MMM DD, YYYY")}
                              </span>
                            ))}
                          </div>

                          <RightCircleOutlined
                            onClick={() => scrollHorizontally(120)}
                            style={{ marginLeft: "10px", cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </div>

                    {/* ================= NDWI ================= */}
                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "320px",
                        background: "#f9fafc",
                        borderRadius: "8px",
                        padding: "12px",
                        boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                        display: "flex",
                        flexDirection: "column",
                        pageBreakInside: "avoid",
                        breakInside: "avoid"
                      }}
                    >
                      <p
                        style={{
                          fontWeight: "600",
                          color: "#006d77",
                          marginBottom: "10px",
                          fontSize: "18px",
                          fontFamily: "Poppins",
                          textAlign: "center"
                        }}
                      >
                        Moisture Stress
                      </p>

                      {ndwiChartOptions ? (
                        <HighchartsReact highcharts={Highcharts} options={ndwiChartOptions} />
                      ) : (
                        <p style={{ textAlign: "center" }}>Loading...</p>
                      )}

                      {/* Date Scroll */}
                      {ndwiLatlongData?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            borderTop: "1px solid #eee",
                            paddingTop: "8px",
                            overflow: "hidden"
                          }}
                        >
                          <LeftCircleOutlined
                            onClick={() => scrollHorizontally(-120)}
                            style={{ marginRight: "10px", cursor: "pointer" }}
                          />

                          <div
                            style={{
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              flex: 1
                            }}
                          >
                            {ndwiLatlongData.map((item, index) => (
                              <span
                                key={index}
                                style={{
                                  display: "inline-block",
                                  padding: "6px 12px",
                                  marginRight: "8px",
                                  borderRadius: "20px",
                                  background: "#e0f7fa",
                                  fontSize: "13px",
                                  fontWeight: "500"
                                }}
                              >
                                {moment(item.date).format("MMM DD, YYYY")}
                              </span>
                            ))}
                          </div>

                          <RightCircleOutlined
                            onClick={() => scrollHorizontally(120)}
                            style={{ marginLeft: "10px", cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* CROP HISTORY ENDS----------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
                {/* HEAT MAP------------------------------>>>>>>>>>>>>>>>> */}

                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 20px",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "20px",
                    background: "#fff",
                    marginTop: "5%",
                    overflow: "hidden",
                    pageBreakInside: "avoid",
                    breakInside: "avoid"
                  }}
                >
                  <p
                    style={{
                       color: "#2f3e0a",
                      fontSize: "26px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      borderBottom: "2px solid #e6e6e6",
                      paddingBottom: "10px",
                      fontFamily: "Poppins"
                    }}
                  >
                    Crop Health Heatmaps
                  </p>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px"
                    }}
                  >

                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "300px",
                        background: "#f9fafc",
                        borderRadius: "8px",
                        padding: "15px",
                        boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                        textAlign: "center"
                      }}
                    >
                      <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                       Crop Health Heatmap 
                      </p>

                      {heatMapData?.data?.image_base64 ? (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <img
                            src={`data:image/png;base64,${heatMapData.data.image_base64}`}
                            alt="Heatmap 1"
                            style={{
                              width: "100%",
                              maxWidth: "500px",
                              height: "320px",
                              objectFit: "contain",
                              borderRadius: "8px"
                            }}
                          />
                        </div>
                      ) : (
                        <p>Loading...</p>
                      )}

                      {heatMapData?.data && (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10%", gap: "8px" }}>

                          <div style={{ width: "300px", height: "18px", overflow: "hidden", position: "relative", borderRadius: "6px" }}>
                            <img
                              src={`${aws_s3_url}/ndvi.png`}
                              alt="Legend"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%) rotate(90deg)",
                                height: "300px",
                                width: "18px"
                              }}
                            />
                          </div>

                          <div style={{ display: "flex", justifyContent: "space-between", width: "300px", fontSize: "12px", fontWeight: "500" }}>
                            <span style={{ color: "#d32f2f" }}>
                              Poor ({heatMapData.data.poor}%)
                            </span>
                            <span style={{ color: "#f9a825" }}>
                              Avg ({heatMapData.data.average}%)
                            </span>
                            <span style={{ color: "#2e7d32" }}>
                              Good ({heatMapData.data.good}%)
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "300px",
                        background: "#f9fafc",
                        borderRadius: "8px",
                        padding: "15px",
                        boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                        textAlign: "center"
                      }}
                    >
                      <p style={{ fontWeight: "600", marginBottom: "10px" }}>
                        Soil Moisture Heatmap
                      </p>

                      {lastHeatMap?.heatmap ? (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <img
                            src={`data:image/png;base64,${lastHeatMap.heatmap}`}
                            alt="Heatmap"
                            style={{
                              width: "100%",
                              maxWidth: "500px",
                              height: "320px",
                              objectFit: "contain",
                              borderRadius: "8px"
                            }}
                          />
                        </div>
                      ) : (
                        <p>Loading...</p>
                      )}

                      {lastHeatMap && (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10%", gap: "8px" }}>

                          <div style={{ width: "300px", height: "18px", overflow: "hidden", position: "relative", borderRadius: "6px" }}>
                            <img
                              src={`${aws_s3_url}/sm.png`}
                              alt="Legend"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%) rotate(90deg)",
                                height: "300px",
                                width: "18px"
                              }}
                            />
                          </div>

                          <div style={{ display: "flex", justifyContent: "space-between", width: "300px", fontSize: "12px", fontWeight: "500" }}>
                            <span style={{ color: "#000000" }}>
                              {/* Poor ({lastHeatMap.poor}%) */}
                              Low
                            </span>
                            <span style={{ color: "#f9a825" }}>
                              {/* Avg ({lastHeatMap.average}%) */}
                              {/* High */}
                            </span>
                            <span style={{ color: "#000000" }}>
                              {/* Good ({lastHeatMap.good}%) */}
                              High
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* HEAT MAP ENDS------------------------------>>>>>>>>>>>>>>>> */}
                {/* CORP HEALTH -------------------------->>>>>>>>>>>>>>>>>>>>>>>. */}

                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 20px",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "20px",
                    background: "#fff",
                    marginTop: "5%",
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                    WebkitColumnBreakInside: "avoid",
                    overflow: "hidden"
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      color: "#2f3e0a",
                      fontSize: "26px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      borderBottom: "2px solid #e6e6e6",
                      paddingBottom: "10px",
                      fontFamily: "Poppins"
                    }}
                  >
                    <Typography
                      style={{
                        color: "#394d09",
                        fontSize: "30px",
                        fontWeight: "600",
                        marginTop: "3%"
                      }}
                    >
                      Crop Health
                    </Typography>
                  </div>

                  {/* Main Section */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "16px",
                      marginTop: "15px"
                    }}
                  >
                    {/* LEFT CARD */}
                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "320px",
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "16px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={pieChartOptions}
                      />

                      {/* Legend */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "40%",
                          marginLeft: "12px"
                        }}
                      >
                        {[
                          { label: "Good Area", value: health?.good, color: "#9fc088" },
                          { label: "Moderate Area", value: health?.average, color: "#e8c07d" },
                          { label: "Poor Area", value: health?.poor, color: "#f55353" }
                        ].map((item, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "6px"
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  backgroundColor: item.color,
                                  width: "14px",
                                  height: "14px",
                                  borderRadius: "8px",
                                  marginRight: "5px"
                                }}
                              />
                              <span>{item.label}</span>
                            </div>
                            <span>{item.value} %</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* RIGHT CARD */}
                    <div
                      style={{
                        flex: "1 1 48%",
                        minWidth: "320px",
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "16px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      <p
                        style={{
                          textAlign: "center",
                          fontWeight: "600",
                          fontSize: "18px",
                          color: "#394d09",
                          marginBottom: "10px",
                          fontFamily: "Poppins"
                        }}
                      >
                        Crop Health Analysis
                      </p>

                      {viChartOptions2 ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={viChartOptions2}
                        />
                      ) : (
                        <p style={{ textAlign: "center" }}>Loading...</p>
                      )}

                      {/* Date Scroll */}
                      {viLatlongData?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            borderTop: "1px solid #eee",
                            paddingTop: "8px",
                            overflow: "hidden"
                          }}
                        >
                          <LeftCircleOutlined
                            onClick={() => scrollHorizontally(-120)}
                            style={{ color: "#394d09", marginRight: "10px", cursor: "pointer" }}
                          />

                          <div
                            style={{
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              flex: 1
                            }}
                          >
                            {viLatlongData.map((item, index) => (
                              <span
                                key={index}
                                style={{
                                  display: "inline-block",
                                  padding: "6px 12px",
                                  marginRight: "8px",
                                  borderRadius: "20px",
                                  background: "#e8f5e9",
                                  color: "#2e7d32",
                                  fontSize: "13px",
                                  fontWeight: "500"
                                }}
                              >
                                {moment(item.date).format("MMM DD, YYYY")}
                              </span>
                            ))}
                          </div>

                          <RightCircleOutlined
                            onClick={() => scrollHorizontally(120)}
                            style={{ color: "#394d09", marginLeft: "10px", cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* CROP HEALTH ENDS---------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
                <div
                  style={{
                    // marginBottom: "20px",
                    padding: "16px",
                    borderRadius: "10px",
                    background: "#ffffff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    border: "1px solid #eee",
                    marginTop: "5%",
                    pageBreakInside: "avoid",
                    breakInside: "avoid",
                    WebkitColumnBreakInside: "avoid"
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      color: "rgb(47, 62, 10)",
                      fontSize: "26px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      borderBottom: "2px solid rgb(230, 230, 230)",
                      paddingBottom: '10px',
                      fontFamily: 'Poppins',
                    }}
                  >
                    <p
                      style={{
                        color: "#2f3e0a",
                        fontSize: "26px",
                        fontWeight: "700",
                        margin: "0",
                        fontFamily: "Poppins"
                      }}
                    >
                       Farm Location
                    </p>
                  </div>

                  {/* Coordinates */}
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "14px",
                      background: "#f9fafc",
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px dashed #ddd"
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "Poppins",
                        margin: 0,
                        fontSize: "14px",
                        color: "#555"
                      }}
                    >
                      Google coordinates to visit the farm:
                      <br />
                      <span style={{ fontWeight: "500" }}>
                        {(() => {
                          const longLat = getLongLat(coordinatesData);
                          return longLat ? (
                            <a
                              href={`https://www.google.com/maps?q=${longLat.lat},${longLat.long}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1976d2",
                                textDecoration: "none",
                                fontWeight: "600"
                              }}
                            >
                              ({longLat.long}, {longLat.lat})
                            </a>
                          ) : (
                            " Not Available"
                          );
                        })()}
                      </span>
                    </p>
                  </div>

                  {/* Image Card */}
                  <div
                    style={{
                      width: "75%",
                      margin: "0 auto",
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                      border: "1px solid #e5e5e5",
                      backgroundColor: "#fff",
                      textAlign: "center",
                      
                    }}
                  >
                    {Object.keys(googgleImages).length ? (
                      <img
                        src={`data:image/png;base64,${googgleImages["satellite"]}`}
                        style={{
                          width: "100%",
                          height: "420px",
                          objectFit: "cover",
                          display: "block"
                        }}
                        alt="Satellite View"
                      />
                    ) : (
                      <div style={{ padding: "40px 0" }}>
                        <img
                          src={`${aws_s3_url}/score-card-loader.gif`}
                          width="50px"
                          alt="Loading"
                        />
                        <p style={{ fontSize: "13px", color: "#888" }}>Loading map...</p>
                      </div>
                    )}
                    <p
                      style={{
                        margin: "10px 0",
                        color: "#444",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "500",
                        letterSpacing: "0.2px"
                      }}
                    >
                       Farm Khasra Boundary
                    </p>
                  </div>
                </div>
{/* ===================================================== */}
              </div>
          </Fragment>
        )}
      </Modal>
    </div>
  );
};

export default FarmerReportDialog;
